import { render } from "./professionUploadVideo.vue?vue&type=template&id=d317f60a&scoped=true"
import script from "./professionUploadVideo.vue?vue&type=script&lang=js"
export * from "./professionUploadVideo.vue?vue&type=script&lang=js"

import "./professionUploadVideo.vue?vue&type=style&index=0&id=d317f60a&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d317f60a"]])

export default __exports__